(function () {'use strict';}());

angular.module('app')
  .controller('ReflectionController', function ($scope,$timeout,$filter,$window,AppService) {
  	var trace = angular.trace;

  	$scope.REFLECTION_SCREEN_LANDING    = 0;
    $scope.REFLECTION_SCREEN_QUESTIONS  = 1;
    $scope.REFLECTION_SCREEN_FEEDBACK_LANDING  = 2;
    $scope.REFLECTION_SCREEN_FEEDBACK  = 3;

    $scope.currentQuestionIndex = 0;
    $scope.currentReflectionScreen = $scope.REFLECTION_SCREEN_QUESTIONS;
    $scope.currentFeedback = null;

    $scope.$watch("questions",onQuestionsSet);

    $scope.selections = [];
    $scope.currentSelection = null;

    $scope.getScreenState = function(value){
      if(value === $scope.currentReflectionScreen) return "on";
      return "off";
    };
    $scope.getQuestionState = function(value){
      if(value === $scope.currentQuestionIndex) return "on";
      return "off";
    };

    $scope.setHomePage = function(){
        $scope.setCurrentPage($scope.PAGE_MENU);
    };

    $scope.prevQuestion = function(){
      if($scope.currentQuestionIndex > 0) {
        $scope.currentQuestionIndex --;
        $scope.currentSelection = $scope.selections[$scope.currentQuestionIndex];
      }
    };

    $scope.skip = function() {
      if($scope.currentQuestionIndex < $scope.selections.length - 1) {
        $scope.currentQuestionIndex ++;
        $scope.next = $scope.selections[$scope.currentQuestionIndex];
        AppService.saveUserResponseForReflection($scope.currentSelection).then(onGoalQuestionSave);
      } else {
        $scope.next= null;
        $scope.currentQuestionIndex = 0;
        AppService.saveUserResponseForReflection($scope.currentSelection).then(function(){
          $scope.setCurrentPage($scope.PAGE_MENU);
        });
      }
    };


    $scope.goalQuestionComplete = function(){
      $scope.containerClasses.saving = true;
      $scope.containerClasses.showLoader = true;

      $timeout(function(){
          $scope.showFeedback($scope.currentSelection.userResponse.id);
          AppService.saveUserResponseForReflection($scope.currentSelection).then(onGoalQuestionSave);
          if($scope.currentQuestionIndex < $scope.selections.length - 1) {
            $scope.currentQuestionIndex ++;
            $scope.next = $scope.selections[$scope.currentQuestionIndex];
          } else {
            $scope.next= null;
          }
          $scope.currentSelection = null;
      }, $scope.TRANSITION_SPEED);
    };

    $scope.hideFeedback = function() {

      $scope.containerClasses.saving = true;
      $scope.containerClasses.showLoader = true;

      $timeout(function(){
        $scope.currentFeedback = null;
        delete $scope.customClasses["reflection-feedback"];
        $scope.containerClasses.saving = false;
        $scope.containerClasses.showLoader = false;

        if($scope.currentSelection) return;

        $scope.setCurrentPage($scope.PAGE_MENU);
      }, $scope.TRANSITION_SPEED);
    };

    $scope.exitToMenu = function() {
      $scope.setCurrentPage($scope.PAGE_MENU);
      $timeout(function(){
        delete $scope.customClasses["reflection-feedback"];
      }, $scope.TRANSITION_SPEED);
    };

    $scope.showFeedback = function(value)
    {
        var data = $filter('reflectionResponse')($scope.responses,parseInt(value));
        if(!data.length) return;
        var option = data[0].options[Math.floor(Math.random()*data[0].options.length)];
        $scope.currentFeedback = option;
        $scope.currentFeedbackType = parseInt(value) <= 2 ? "positive" : "negative";
        $scope.customClasses["reflection-feedback"] = true;
    };

    function onGoalQuestionSave(result)
    {
      $timeout(function(){
        $scope.containerClasses.saving = false;
        $scope.containerClasses.showLoader = false;
        $scope.currentSelection = $scope.next;
        if(result && !result.data.authenticated) $window.location.reload();
      }, $scope.TRANSITION_SPEED);
      
    }


    function onQuestionsSet(event,data){
      if(!event) return;

      $scope.images = AppService.reflectionImages;
      $scope.selections = AppService.reflectionSelections;
      $scope.currentQuestionIndex = 0;
      $scope.currentSelection = $scope.selections[$scope.currentQuestionIndex];
      $scope.responses = [{id:0,title:"Select an option",value:0}].concat(AppService.reflectionResponses);
      $scope.currentFeedback = null;

      var rids = $scope.responses.map(function(e){ return e.id; });



      $scope.selections.forEach(function(e){
        if(e.configured) return;
        if(!e.userResponse) e.userResponse = $scope.responses[0];
        else e.userResponse = $scope.responses[rids.indexOf(parseInt(e.userResponse))];
        e.configured = true;
      });

      trace($scope.selections);

      var complete = $scope.selections.filter(function(e){ return e.userResponse.id !== 0; });
      
      if(complete.length === $scope.selections.length) {
        $scope.showCompleteScreen = true;
      }

    }

  });